import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Facebook, Instagram } from 'lucide-react';
// Custom TikTok Icon since it's not in lucide-react by default
const TikTokIcon = ({
  className
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-19">
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" data-id="element-20" />
  </svg>;
export function Contact() {
  return <section className="py-24 bg-brand-cream relative overflow-hidden" id="contacto" data-id="element-21">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-brand-beige/30 rounded-l-full blur-3xl -z-10" data-id="element-22"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-24">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-25">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-green mb-6" data-id="element-26">
              ¿Quieres saber cuál extracto puede acompañar mejor tu rutina?
            </h2>
            <p className="text-lg text-brand-brown/80 mb-10 leading-relaxed" data-id="element-27">
              Escríbenos por WhatsApp y te orientamos según lo que buscas:
              energía, equilibrio, enfoque o bienestar general.
            </p>

            <a href="https://wa.me/56965576936?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20los%20extractos%20de%20hongos" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 bg-brand-green text-white text-lg font-medium rounded-full hover:bg-brand-lightGreen transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 w-full sm:w-auto mb-12" data-id="element-28">
              <MessageCircle className="mr-2" size={24} data-id="element-29" />
              Consultar por WhatsApp
            </a>

            <div data-id="element-30">
              <p className="text-sm font-bold text-brand-brown/60 uppercase tracking-wider mb-4" data-id="element-31">
                Síguenos en redes sociales
              </p>
              
            </div>
          </motion.div>

          
        </div>
      </div>
    </section>;
}